import { render, staticRenderFns } from "./FATabs.vue?vue&type=template&id=18cc2746&scoped=true"
import script from "./FATabs.vue?vue&type=script&lang=js"
export * from "./FATabs.vue?vue&type=script&lang=js"
import style0 from "./FATabs.vue?vue&type=style&index=0&id=18cc2746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc2746",
  null
  
)

export default component.exports